// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Device Form Styles */
.device-form-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  padding: 20px;
}

.device-form-modal {
  background: white;
  border-radius: 12px;
  width: 100%;
  max-width: 500px;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
}

.device-form-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  border-bottom: 1px solid #e0e0e0;
}

.device-form-header h3 {
  margin: 0;
  color: #075E54;
  font-size: 20px;
}

.close-btn {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #666;
  padding: 0;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.close-btn:hover {
  background: #f5f5f5;
}

.device-form {
  padding: 24px;
}

.form-group {
  margin-bottom: 20px;
}

.form-group label {
  display: block;
  margin-bottom: 6px;
  font-weight: 500;
  color: #075E54;
  font-size: 14px;
}

.form-group input,
.form-group textarea {
  width: 100%;
  padding: 12px 16px;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  font-size: 14px;
  transition: border-color 0.3s ease;
  box-sizing: border-box;
}

.form-group input:focus,
.form-group textarea:focus {
  outline: none;
  border-color: #25D366;
}

.form-group input:disabled,
.form-group textarea:disabled {
  background-color: #f5f5f5;
  cursor: not-allowed;
}

.form-group small {
  display: block;
  margin-top: 4px;
  font-size: 12px;
  color: #666;
}

.api-key-input {
  display: flex;
  gap: 8px;
}

.api-key-input input {
  flex: 1 1;
}

.generate-btn {
  background: #6c757d;
  color: white;
  border: none;
  padding: 12px 16px;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  white-space: nowrap;
  transition: background-color 0.3s ease;
}

.generate-btn:hover:not(:disabled) {
  background: #545b62;
}

.generate-btn:disabled {
  background: #ccc;
  cursor: not-allowed;
}

.error-message {
  background-color: #ffebee;
  color: #c62828;
  padding: 12px;
  border-radius: 6px;
  font-size: 14px;
  text-align: center;
  border: 1px solid #ffcdd2;
  margin-bottom: 20px;
}

.form-actions {
  display: flex;
  gap: 12px;
  padding-top: 16px;
  border-top: 1px solid #e0e0e0;
}

.cancel-btn {
  background: #6c757d;
  color: white;
  border: none;
  padding: 12px 20px;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  flex: 1 1;
  transition: background-color 0.3s ease;
}

.cancel-btn:hover:not(:disabled) {
  background: #545b62;
}

.save-btn {
  background: #25D366;
  color: white;
  border: none;
  padding: 12px 20px;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  flex: 1 1;
  transition: background-color 0.3s ease;
}

.save-btn:hover:not(:disabled) {
  background: #1da851;
}

.save-btn:disabled,
.cancel-btn:disabled {
  background: #ccc;
  cursor: not-allowed;
}

/* Responsive Design */
@media (max-width: 640px) {
  .device-form-modal {
    margin: 10px;
    max-width: none;
  }
  
  .device-form {
    padding: 16px;
  }
  
  .api-key-input {
    flex-direction: column;
  }
  
  .api-key-input input {
    margin-bottom: 8px;
  }
  
  .form-actions {
    flex-direction: column;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/DeviceForm.css"],"names":[],"mappings":"AAAA,uBAAuB;AACvB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,WAAW;EACX,UAAU;EACV,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,kCAAkC;EAClC,sBAAsB;AACxB;;AAEA;;EAEE,aAAa;EACb,qBAAqB;AACvB;;AAEA;;EAEE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,SAAO;EACP,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,SAAO;EACP,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE;IACE,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;EACxB;AACF","sourcesContent":["/* Device Form Styles */\n.device-form-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.7);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n  padding: 20px;\n}\n\n.device-form-modal {\n  background: white;\n  border-radius: 12px;\n  width: 100%;\n  max-width: 500px;\n  max-height: 90vh;\n  overflow-y: auto;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);\n}\n\n.device-form-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 20px 24px;\n  border-bottom: 1px solid #e0e0e0;\n}\n\n.device-form-header h3 {\n  margin: 0;\n  color: #075E54;\n  font-size: 20px;\n}\n\n.close-btn {\n  background: none;\n  border: none;\n  font-size: 24px;\n  cursor: pointer;\n  color: #666;\n  padding: 0;\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.close-btn:hover {\n  background: #f5f5f5;\n}\n\n.device-form {\n  padding: 24px;\n}\n\n.form-group {\n  margin-bottom: 20px;\n}\n\n.form-group label {\n  display: block;\n  margin-bottom: 6px;\n  font-weight: 500;\n  color: #075E54;\n  font-size: 14px;\n}\n\n.form-group input,\n.form-group textarea {\n  width: 100%;\n  padding: 12px 16px;\n  border: 2px solid #e0e0e0;\n  border-radius: 8px;\n  font-size: 14px;\n  transition: border-color 0.3s ease;\n  box-sizing: border-box;\n}\n\n.form-group input:focus,\n.form-group textarea:focus {\n  outline: none;\n  border-color: #25D366;\n}\n\n.form-group input:disabled,\n.form-group textarea:disabled {\n  background-color: #f5f5f5;\n  cursor: not-allowed;\n}\n\n.form-group small {\n  display: block;\n  margin-top: 4px;\n  font-size: 12px;\n  color: #666;\n}\n\n.api-key-input {\n  display: flex;\n  gap: 8px;\n}\n\n.api-key-input input {\n  flex: 1;\n}\n\n.generate-btn {\n  background: #6c757d;\n  color: white;\n  border: none;\n  padding: 12px 16px;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 14px;\n  white-space: nowrap;\n  transition: background-color 0.3s ease;\n}\n\n.generate-btn:hover:not(:disabled) {\n  background: #545b62;\n}\n\n.generate-btn:disabled {\n  background: #ccc;\n  cursor: not-allowed;\n}\n\n.error-message {\n  background-color: #ffebee;\n  color: #c62828;\n  padding: 12px;\n  border-radius: 6px;\n  font-size: 14px;\n  text-align: center;\n  border: 1px solid #ffcdd2;\n  margin-bottom: 20px;\n}\n\n.form-actions {\n  display: flex;\n  gap: 12px;\n  padding-top: 16px;\n  border-top: 1px solid #e0e0e0;\n}\n\n.cancel-btn {\n  background: #6c757d;\n  color: white;\n  border: none;\n  padding: 12px 20px;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 14px;\n  flex: 1;\n  transition: background-color 0.3s ease;\n}\n\n.cancel-btn:hover:not(:disabled) {\n  background: #545b62;\n}\n\n.save-btn {\n  background: #25D366;\n  color: white;\n  border: none;\n  padding: 12px 20px;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 14px;\n  flex: 1;\n  transition: background-color 0.3s ease;\n}\n\n.save-btn:hover:not(:disabled) {\n  background: #1da851;\n}\n\n.save-btn:disabled,\n.cancel-btn:disabled {\n  background: #ccc;\n  cursor: not-allowed;\n}\n\n/* Responsive Design */\n@media (max-width: 640px) {\n  .device-form-modal {\n    margin: 10px;\n    max-width: none;\n  }\n  \n  .device-form {\n    padding: 16px;\n  }\n  \n  .api-key-input {\n    flex-direction: column;\n  }\n  \n  .api-key-input input {\n    margin-bottom: 8px;\n  }\n  \n  .form-actions {\n    flex-direction: column;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
